import { render, staticRenderFns } from "./TextareaFormInput.vue?vue&type=template&id=2cbea33a&scoped=true&"
import script from "./TextareaFormInput.vue?vue&type=script&lang=ts&"
export * from "./TextareaFormInput.vue?vue&type=script&lang=ts&"
import style0 from "./TextareaFormInput.vue?vue&type=style&index=0&id=2cbea33a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbea33a",
  null
  
)

export default component.exports